import { Analytics, Auth, Hub } from 'aws-amplify';
import { recordAnalyticsEvent } from './recordAnalyticsEvent';

const configureAnalytics = async (user) => {
  Analytics.configure({
    disabled: false,
    autoSessionRecord: true,
    AWSPinpoint: {
      appId: process.env.REACT_APP_PINPOINT_PROJECT_ID,
      region: 'eu-west-1',
      endpointId: user.attributes.sub,
      endpoint: {
        address: user.attributes.sub,
        attributes: {
          group: [user.signInUserSession.idToken.payload.group],
          subgroup: [user.signInUserSession.idToken.payload.subgroup]
        },
        userAttributes: {
          username: [user.attributes.preferred_username || user.username],
          email: [user.attributes.email],
          role: [user.signInUserSession.idToken.payload.role]
        },
        userId: user.username
      }
    }
  });
};

Analytics.autoTrack('event', {
  enable: true,
  events: ['click'],
  selectorPrefix: 'data-analytics-',
  provider: 'AWSPinpoint'
});

Hub.listen('auth', async ({ payload: { event, data: user } }) => {
  switch (event) {
    case 'configured':
      try {
        const user = await Auth.currentAuthenticatedUser();
        if (user) {
          configureAnalytics(user);
        }
      } catch (error) {
        // Do not throw error if user is not authenticated
        if (!error.includes('not authenticated')) {
          throw error;
        }
      }
      break;
    case 'signIn': {
      const user = await Auth.currentAuthenticatedUser();
      if (user) {
        configureAnalytics(user);
        recordAnalyticsEvent('user.login', {});
      }
      break;
    }
    case 'cognitoHostedUI':
      console.log('hub from analytics: cognitoHostedUI');
      break;
  }
});
